import { render } from "./ThinBarChart.vue?vue&type=template&id=b375e04e"
import script from "./ThinBarChart.vue?vue&type=script&lang=js"
export * from "./ThinBarChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__